.firstColumn {
	@apply
	yst-flex
	yst-flex-col
	yst-gap-4
	yst-items-center
	yst-justify-center
	yst-text-center
	yst-max-w-lg;

	.asideIcon {
		@apply
		yst-w-40
		yst-h-40;
	}

	h1, p {
		@apply
		yst-w-5/6;
	}
}
